<template>
  <div class="list-filters" :class="{ 'is-fixed': isMapDisplayed }">
    <button type="button" class="list-filter-mobile-button list-filters-toggle">
      <IconFilter /> Filter
    </button>

    <div class="list-filters-wrap">
      <div class="list-filters-mobile-top">
        <div class="list-filters-mobile-top-heading">
          Filter <span class="list-filters-mobile-top-heading-num"></span>
        </div>
        <div class="list-filters-mobile-top-results">{{ resultsCount }} results</div>
      </div>

      <div class="list-filters-mobile-inner">
        <div class="list-filter-wrap">
          <div class="list-filters-mobile-inner-block-heading">
            Price <span class="list-filters-mobile-inner-block-heading-num"></span>
          </div>

          <button type="button" class="list-filter-toggle">
            <span class="list-filter-toggle-text">
              Price <span class="list-filter-toggle-text-num"></span>
            </span>
            <IconTriangleDown />
          </button>

          <div class="list-filter-dropdown is-price">
            <div class="list-filter-price">
              <div class="list-filter-price-input">
                <input type="text" class="form-input mask-number" id="price-min">
                <div class="list-filter-price-input-dollar">$</div>
              </div>
              <div class="list-filter-price-hyphen">-</div>
              <div class="list-filter-price-input">
                <input type="text" class="form-input mask-number" id="price-max">
                <div class="list-filter-price-input-dollar">$</div>
              </div>
            </div>
            <div class="list-filter-price">
              <div class="list-filter-price-input list-filter-price-input-suggestions is-active" id="list-filter-price-input-suggestions-min">
                <button
                    v-for="(price, i) in prices"
                    type="button"
                    data-price="price-min"
                    class="list-filter-price-button"
                    :data-value="price"
                    :key="`price-min-button-key-${i}`"
                    @click="setPrice('minPrice', price)"
                >
                  ${{ price }}
                </button>
              </div>
              <div class="list-filter-price-hyphen"></div>
              <div class="list-filter-price-input list-filter-price-input-suggestions" id="list-filter-price-input-suggestions-max">
                <button
                    v-for="(price, i) in prices"
                    type="button"
                    data-price="price-max"
                    class="list-filter-price-button"
                    :data-value="price"
                    :key="`price-max-button-key-${i}`"
                    @click="setPrice('maxPrice', price)"
                >
                  ${{ price }}
                </button>
              </div>
            </div>
            <div class="list-filter-footer">
              <button type="button" class="list-filter-clear" @click="clearPrices">Clear all</button>
            </div>
          </div>
        </div>

        <div class="list-filter-wrap" data-filter="property-type">
          <div class="list-filters-mobile-inner-block-heading">
            Beds &amp; Baths <span class="list-filters-mobile-inner-block-heading-num"></span>
          </div>

          <button type="button" class="list-filter-toggle">
            <span class="list-filter-toggle-text list-filter-toggle-text-bedbath">
              Beds &amp; Baths <span class="list-filter-toggle-text-num"></span>
            </span>
            <IconTriangleDown />
          </button>

          <div class="list-filter-dropdown is-bedbath">
            <div class="list-filter-dropdown-title">Bedrooms</div>
            <div class="faux-radio-row">
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bed_any" name="filter-bed" :value="0" v-model="filterBeds">
                <label class="faux-radio-label" for="bed_any">Any</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bed_1" name="filter-bed" :value="1" v-model="filterBeds">
                <label class="faux-radio-label" for="bed_1">1+</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bed_2" name="filter-bed" :value="2" v-model="filterBeds">
                <label class="faux-radio-label" for="bed_2">2+</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bed_3" name="filter-bed" :value="3" v-model="filterBeds">
                <label class="faux-radio-label" for="bed_3">3+</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bed_4" name="filter-bed" :value="4" v-model="filterBeds">
                <label class="faux-radio-label" for="bed_4">4+</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bed_5" name="filter-bed" :value="5" v-model="filterBeds">
                <label class="faux-radio-label" for="bed_5">5+</label>
              </div>
            </div>

            <div class="list-filter-dropdown-title">Baths</div>
            <div class="faux-radio-row">
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bath_any" name="filter-bath" :value="0" v-model="filterBaths">
                <label class="faux-radio-label" for="bath_any">Any</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bath_1" name="filter-bath" :value="1" v-model="filterBaths">
                <label class="faux-radio-label" for="bath_1">1+</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bath_2" name="filter-bath" :value="2" v-model="filterBaths">
                <label class="faux-radio-label" for="bath_2">2+</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bath_3" name="filter-bath" :value="3" v-model="filterBaths">
                <label class="faux-radio-label" for="bath_3">3+</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bath_4" name="filter-bath" :value="4" v-model="filterBaths">
                <label class="faux-radio-label" for="bath_4">4+</label>
              </div>
              <div class="faux-radio-wrap">
                <input class="faux-radio-input" type="radio" id="bath_5" name="filter-bath" :value="5" v-model="filterBaths">
                <label class="faux-radio-label" for="bath_5">5+</label>
              </div>
            </div>

            <div class="list-filter-footer">
              <button type="button" class="list-filter-clear">Clear all</button>
            </div>
          </div>
        </div>

        <div class="list-filter-wrap" data-filter="neighborhoods">
          <div class="list-filters-mobile-inner-block-heading">
            Neighborhoods <span class="list-filters-mobile-inner-block-heading-num"></span>
          </div>

          <button type="button" class="list-filter-toggle is-small">
            <span class="list-filter-toggle-text">
              Neighborhoods <span class="list-filter-toggle-text-num"></span>
            </span>
            <IconTriangleDown />
          </button>

          <div class="list-filter-dropdown">
            <div
              class="list-filter-checkbox faux-checkbox-wrap"
              v-for="(neighborhood, i) in neighborhoods"
              :key="`neighborhoods-${i}`"
            >
              <input
                class="faux-checkbox-input"
                type="checkbox"
                :id="`neighborhood_${neighborhood}`"
                :name="`neighborhood_${neighborhood}`"
                :value="neighborhood"
                v-model="filterNeighborhoods"
              />
              <label
                class="list-filter-checkbox-label faux-checkbox-label"
                :for="`neighborhood_${neighborhood}`"
              >
                {{ neighborhood }}
              </label>
            </div>

            <div class="list-filter-footer">
              <button type="button" class="list-filter-clear" @click="filterNeighborhoods = []">Clear all</button>
            </div>
          </div>
        </div>
      </div>

      <div class="list-filters-mobile-bottom">
        <button type="button" class="list-filters-mobile-bottom-clear" @click="clearAllFilters">Clear all</button>
        <button type="button" class="list-filters-mobile-bottom-done list-filters-toggle">
          Done
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import IconFilter from '@/components/icons/IconFilter';
import IconTriangleDown from '@/components/icons/IconTriangleDown';

export default {
  name: 'QuickMoveInMapFilters',
  components: { IconFilter, IconTriangleDown },
  props: {
    beds: {
      type: Array,
      required: true,
    },
    baths: {
      type: Array,
      required: true,
    },
    neighborhoods: {
      type: Array,
      required: true,
    },
    prices: {
      type: Array,
      required: true,
    },
    resultsCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isMapDisplayed() {
      return this.$store.getters['ui/isMapDisplayed'];
    },
    filterBaths: {
      get() {
        return this.$store.getters['quickMoveIns/getFilter']('baths');
      },
      set(value) {
        this.$store.dispatch('quickMoveIns/setFilter', { field: 'baths', value });
      },
    },
    filterBeds: {
      get() {
        return this.$store.getters['quickMoveIns/getFilter']('beds');
      },
      set(value) {
        this.$store.dispatch('quickMoveIns/setFilter', { field: 'beds', value });
      },
    },
    filterNeighborhoods: {
      get() {
        return this.$store.getters['quickMoveIns/getFilter']('neighborhoods');
      },
      set(value) {
        this.$store.dispatch('quickMoveIns/setFilter', { field: 'neighborhoods', value });
      },
    },
  },
  methods: {
    clearBedsAndBaths() {
      this.$store.dispatch('quickMoveIns/setFilter', { field: 'beds', value: [] });
      this.$store.dispatch('quickMoveIns/setFilter', { field: 'baths', value: [] });
    },
    clearPrices() {
      this.$store.dispatch('quickMoveIns/setFilter', { field: 'minPrice', value: false });
      this.$store.dispatch('quickMoveIns/setFilter', { field: 'maxPrice', value: false });
    },
    clearAllFilters() {
      this.clearBedsAndBaths();
      this.clearPrices();
      this.$store.dispatch('quickMoveIns/setFilter', { field: 'neighborhoods', value: [] });
    },
    setPrice(field, value) {
      this.$store.dispatch('quickMoveIns/setFilter', { field, value });
    },
  },
};
</script>
